import React from "react";
import { useExpertProfileContext } from "../expert-profile/ExpertProfileContext";
export const useMessagesPendingFeeAllocation = () => {
  const {
    profile
  } = useExpertProfileContext();
  const [pendingFeeAllocation, setPendingFeeAllocation] = React.useState(profile.mgsPendingFeeAllocation || 0);
  React.useEffect(() => {
    setPendingFeeAllocation(profile.mgsPendingFeeAllocation);
  }, [profile.mgsPendingFeeAllocation]);
  const updateMessagePendingFeeAllocation = newCount => {
    setPendingFeeAllocation(newCount);
  };
  return {
    pendingFeeAllocation,
    updateMessagePendingFeeAllocation
  };
};